import {
  TypographyColor,
  TypographyVariant,
} from "../../../constants/typography";
import { Typography } from "../../core/Typography/Typography";
import { FC, HTMLAttributes, useRef } from "react";
import { useStyles } from "./VideoCard.style";
import { Time } from "../../../models/time";
import { VideoItem } from "@onmo/graphql/graphql";

export const VideoCard: FC<
  {
    video: VideoItem;
    isPlayingVideo?: boolean;
  } & HTMLAttributes<HTMLDivElement>
> = ({ video, isPlayingVideo, ...otherProps }) => {
  const classes = useStyles();
  const elementRef = useRef<HTMLDivElement>(null);

  const renderVideo = () => {
    if (isPlayingVideo) {
      return (
        <iframe
          className={classes.videoThumbnail}
          src={`https://www.youtube.com/embed/${video.id}?autoplay=1&mute=1`}
          title={"video" + video.id}
          allowFullScreen
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        />
      );
    } else {
      return (
        <img
          src={video.thumbnailUrl.high}
          alt="Video thumbnail"
          className={classes.videoThumbnail}
        />
      );
    }
  };

  return (
    <div {...otherProps} ref={elementRef}>
      {renderVideo()}
      <div className={classes.videoInfo}>
        <div className={classes.info}>
          <Typography variant={TypographyVariant.BodyB4Medium} lines={1}>
            {video.title}
          </Typography>
          <div className={classes.description}>
            <Typography
              variant={TypographyVariant.BodyB5Regular}
              color={TypographyColor.Silver}
              lines={1}
              className={classes.descriptionContent}
            >
              {video.description}
            </Typography>
            <Typography
              variant={TypographyVariant.BodyB6Regular}
              color={TypographyColor.Silver}
              lines={1}
            >
              {Time.getTimeAgo(video.publishedAt)}
            </Typography>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoCard;
